/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/DebouncedModel.js");
var escapeRegexp = require("escape-regexp");
var par = require("par");
var debounce = require("debounce");

module.exports = Model({
	name: "management",
	_list: null,
	_filter: null,
	pass_through_users: pass_through_users,
	init: init,
	listeners: listeners,
	triggers: triggers,
	debounce: 100, // Debounce pushes by 50 milliseconds
});

function init() {
	this._list = [];
	this._filter = null;

	this.push({
		account: {}, // The personal info of the managed person
		atouchaway: {}, // The managed atouchaway settings
		simplified: {}, // The managed simplified settings
		bracelet: {}, // The managed bracelet settings
		careplan: {}, // Careplan data
		contact_remove: null,
		contact_requests: {}, //The contact requests,
		contact_invites: [],
		contacts: {}, // The contact list/requests of the managed person
		filedata: {}, // THe data for managed files being viewed
		forms: {}, // The managed forms for a person
		list: [], // The managed contact list
		management_removed: false,
		managers: {}, // The managed managers
		managerpermissions: [], // Permissions of a chosen manager for a given user
		managedmanagerrequests: [], // Search for new care team members, list outgoing requests
		managedreminderhistory: {}, //the state of users reminder history
		managers_remove: null, // If manager being removed, manager _id.  Else null or false
		metrics: {}, // The cumulative metrics for managed user
		open: false, // Wether there is a person currently being managed
		pendingReminders: [], // Pending reminders for this managed person
		permissions: {}, // The permissions of a manager for a given User's info
		picture: {}, // The state of updating the managed user's profile picture
		preferences: {}, // The managed preferences state
		reminder_maker: {}, // The reminder maker for managed reminders
		reminders: [], // The reminders for this managed person
		removing: null,
		requests: {}, // The management requests
		surveys: {}, // The state of surveys being initiated (sent)
		urgencycontacts: {}, // The managed urgency contacts
		urgencypotentials: {}, // Potential urgency contacts
		visible: true, // Whether the managed account list should be shown or collapsed
		workflow: {},
		managedactivity: [], // Object containing history of steps and cumulative total,
		managedgroupformlist: [],
		managedgroupformorderedlist: [], //List of group forms but ordered
		managedgroupformsubmissions: [],
		managedactivegroupformsubmission: {},
		managedactivegroupformprepopulate: {},
		managedbloodsugar: [], // Object containing history of blood sugar readings and cumulative total
		managedbloodpressure: [], // Object containing history of blood pressure readings and cumulative total
		managedweight: [], // Object containing history of weight readings and cumulative total
		managedbloodoxygen: [], // Object containing history of blood oxygen readings and cumulative total
		managedbodytemperature: [], // Object containing history of body temperature readings and cumulative total
		managedcomment: {}, // Object containing the latest reading comment to be displayed.
		managedcustomindicatorslist: [],
		managedcustomindicator: [],
		managedusergroup: null,
		managedstatuses: {},
		resources: [],
		devices: [],
		defaultPermissions: null,
		presetPermissions: null,
		urgencyPreferences: {},
		managedEnd: {}
	});
}

function listeners() {
	return {
		"managedaccount:updated": handle_managed_account_update,
		"managedatouchaway:updated": Model.makeExtender("atouchaway"),
		"managedsimplified:updated": Model.makeExtender("simplified"),
		"managedbracelet:updated": Model.makeExtender("bracelet"),
		"managedcareplan:updated": Model.makeExtender("careplan"),
		"managedcareplanexpander:updated": Model.makeExtender("careplanexpanded"),
		"managedcontactrequests:updated": Model.makeExtender("contact_requests"),
		"managedcontacts:updated": Model.makeExtender("contacts"),
		"managedfiledata:updated": Model.makeExtender("filedata"),
		"managedforms:updated": Model.makeExtender("forms"),
		"managedmanagerpermissions:updated": Model.makeExtender("managerpermissions"),
		"managedmanagerrequests:updated": Model.makeExtender("managedmanagerrequests"),
		"managedmanagers:updated": Model.makeExtender("managers"),
		"managedmetrics:updated": Model.makeExtender("metrics"),
		"managednewsectionupdates:updated": Model.makeExtender("newsections"),
		"managedpendingreminders:updated": Model.makeExtender("pendingReminders"),
		"managedpreferences:updated": Model.makeExtender("preferences"),
		"managedprofilepicture:updated": Model.makeExtender("picture"),
		"managedremindermaker:updated": Model.makeExtender("reminder_maker"),
		"managedreminders:updated": Model.makeExtender("reminders"),
		"managedreminderhistory:updated": Model.makeExtender("managedreminderhistory"),
		"managedsectionupdates:updated": Model.makeExtender("allSections"),
		"managedurgencycontacts:updated": Model.makeExtender("urgencycontacts"),
		"managedurgencypotentials:updated": Model.makeExtender("urgencypotentials"),
		"managedusers:updated": handle_managed_users_update,
		"managementpermissions:updated": Model.makeExtender("permissions"),
		"managementrequests:updated": Model.makeExtender("requests"),
		"surveyinitiate:updated": Model.makeExtender("surveys"),
		"managedworkflow:updated": Model.makeExtender("workflow"),
		"managedactivity:updated": Model.makeExtender("managedactivity"),
		"managedgroupformlist:updated": Model.makeExtender("managedgroupformlist"),
		"managedgroupformorderedlist:updated": Model.makeExtender("managedgroupformorderedlist"),
		"managedgroupformsubmissions:updated": Model.makeExtender("managedgroupformsubmissions"),
		"managedactivegroupformsubmission:updated": Model.makeExtender("managedactivegroupformsubmission"),
		"managedactivegroupformprepopulate:updated": Model.makeExtender("managedactivegroupformprepopulate"),
		"managedbloodsugar:updated": Model.makeExtender("managedbloodsugar"),
		"managedbloodpressure:updated": Model.makeExtender("managedbloodpressure"),
		"managedweight:updated": Model.makeExtender("managedweight"),
		"managedbloodoxygen:updated": Model.makeExtender("managedbloodoxygen"),
		"managedbodytemperature:updated": Model.makeExtender("managedbodytemperature"),
		"managedcomment:updated": Model.makeExtender("managedcomment"),
		"managedusergroup:updated": Model.makeExtender("managedusergroup"),
		"managedstatuses:updated": Model.makeExtender("managedstatuses"),
		"managedresources:updated": Model.makeExtender("resources"),
		"managedresourceslist:updated": Model.makeExtender("resourceslist"),
		"manageddevices:updated": Model.makeExtender("devices"),
		"manageddefaultmanagerpermissions:updated": Model.makeExtender("defaultPermissions"),
		"managedpresetmanagerpermissions:updated": Model.makeExtender("presetPermissions"),
		"managedurgencypreferences:updated": Model.makeExtender("urgencyPreferences"),
		"managedaccountinvites:updated": Model.makeExtender("contact_invites"),
		"managedusersend:updated": Model.makeExtender("managedEnd"),
		"managedcustomindicatorslist:updated": Model.makeExtender("managedcustomindicatorslist"),
		"managedcustomindicator:updated": Model.makeExtender("managedcustomindicator")
	};
}

function triggers() {
	return {
		"filter": debounce(handle_filter_change.bind(this), 200),
		"remove:managment:start": handle_management_trigger_remove_start,
		"remove:managment:cancel": handle_management_trigger_remove_cancel,
		"remove:managment": handle_management_trigger_remove,
		"remove:managment:confirm": handle_management_trigger_remove_accepted,
		"remove:contact:start": handle_contact_trigger_remove_start,
		"remove:contact:cancel": handle_contact_trigger_remove_cancel,
		"remove:contact": handle_management_trigger_contact_remove,
		"remove:contact:confirm": handle_management_trigger_contact_remove_confirm,
		"toggle": handle_trigger_toggle,
		"remove:manager:start": handle_management_trigger_manager_remove_start,
		"remove:manager:confirm": handle_management_trigger_manager_remove_confirm,
		"remove:manager:cancel": handle_management_trigger_manager_remove_cancel,
		"remove:manager": handle_management_trigger_manager_remove,
	};
}

function handle_management_trigger_manager_remove_start(data) {
	var who = data.who;
	this.extend({
		managers_remove: who
	});

	this.emit("usermetrics:trigger:track", "open remove managed manager confirmation popup", {
		who: who
	});
}

function handle_management_trigger_manager_remove_confirm(data) {
	var manager = data.who;
	const group = data.group || this.data.group;
	this.emit("managedmanagers:trigger:remove", {
		who: manager,
		group
	});
	this.extend({
		managers_remove: false
	});
	this.emit("usermetrics:trigger:track", "confirm remove managed manager", {
		who: manager
	});
}

function handle_management_trigger_manager_remove_cancel() {
	const who = this.data.managers_remove;
	this.extend({
		managers_remove: false
	});
	this.emit("usermetrics:trigger:track", "close remove managed manager confirmation popup", {
		who,
	});
}

function handle_management_trigger_manager_remove(data) {
	var who = data.who;
	this.extend({
		manager_remove: who
	});
	this.dispatch("managedmanagersremoving", {
		who: who
	});
	this.emit("usermetrics:trigger:track", "open remove managed manager confirmation popup", {
		who,
	});
}

function handle_managed_users_update(users) {
	this._list = users;
	this.pass_through_users();
}

/**
 * Filters people by a certain regex. Uses their full name for filtering
 * @param  {RegExp} regex  The Regular Expression to filter with
 * @param  {Object} person A person with an fname, lname
 * @return {Boolean}        True if person matches the regex
 */
function filter_by(regex, person) {
	var identity = [person.fname, person.lname].join(" ");
	var matches = identity.match(regex);
	return !!matches;
}

/**
 * Re-creates the filter and re-displays the lists based on it
 * @param  {Object} data Should contain the `filter` string. A list of space-delimited words
 * @return {[type]}      [description]
 */
function handle_filter_change(data) {
	var filter = data.filter;

	if (!filter)
		this._filter = null;
	else this._filter = process_filter_text(filter);

	this.pass_through_users();

	this.emit("usermetrics:trigger:track", "filter managed users list", {
		filter: filter
	});
}

/**
 * Creates a regular expression from the filter text.
 * Escapes special characters and ORs the words for matching
 * @param  {String} filter Filter text to turn into a RegExp
 * @return {RegExp}        The resulting regular expression
 */
function process_filter_text(filter) {
	var escaped_text = escapeRegexp(filter);

	var replaced_spaces = escaped_text.replace(/\W+/g, "|");

	return new RegExp(replaced_spaces, "ig");
}

/**
 * Filters through the managed user list and upates list property in model
 */
function pass_through_users() {
	var list = this._list;
	var filter = this._filter;

	if (filter)
		list = list.filter(par(filter_by, filter));

	// Push down the update
	this.extend({
		list: list
	});
}

function handle_management_trigger_remove_start(data) {
	var who = data.who;
	this.extend({
		removing: who
	});
	this.emit("usermetrics:trigger:track", "open remove managed user confirmation popup", {
		who,
	});
}

function handle_management_trigger_remove_cancel() {
	this.extend({
		removing: false
	});
	this.emit("usermetrics:trigger:track", "close remove managed user confirmation popup", {
		who: this.data.who,
	});
}

function handle_management_trigger_remove(data) {
	var who = data.who;
	this.dispatch("removemanagement", {
		who: who
	});
	this.emit("usermetrics:trigger:track", "remove managed user", {
		who: who
	});
}

function handle_management_trigger_remove_accepted(data) {
	this.emit("save:trigger:start");
	var who = data.who;
	var removeContact = data.removeContact;
	const group = data.group || this.data.group;
	if(removeContact)
		this.emit("allcontacts:trigger:remove:contact:confirm", {
			who: who,
			group
		});
	this.api.manage.remove(who, group)
		.catch(console.error.bind(console))
		.then(set_removed_success.bind(this));

	this.emit("usermetrics:trigger:track", "confirm remove managed user", {
		who,
	});
}

function handle_management_trigger_contact_remove_confirm(data) {
	var who = data.who;
	const group = data.group || this.data.group;

	this.emit("managedcontacts:trigger:remove", {
		who: who,
		group
	});

	this.emit("toast:trigger:show", {
		content: "managedcontacts.removed"
	});

	this.extend({
		removing: false
	});

	this.emit("usermetrics:trigger:track", "confirm remove managed contact", {
		who,
	});
}

function handle_trigger_toggle() {
	this.extend({
		visible: !this.data.visible
	});

	this.emit("usermetrics:trigger:track", "toggle managed user list", {
		visible: this.data.visible
	});
}

function set_removed_success() {
	this.extend({
		management_removed: true
	});
	this.extend({
		removing: false
	});
	var message = "management.removed";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
	this.emit("save:trigger:finish");
	this.dispatch("managementremoved");
}

function handle_managed_account_update(managedaccount) {
	this.extend({
		account: managedaccount.data,
		open: managedaccount.open,
		group: managedaccount.group
	});
}

function handle_management_trigger_contact_remove(data) {
	var who = data.who;
	this.extend({
		contact_remove: who
	});
	this.dispatch("managedcontactremoving", {
		who: who
	});
	this.emit("usermetrics:trigger:track", "open remove managed contact confirmation popup", {
		who,
	});
}

function handle_contact_trigger_remove_start(data) {
	var who = data.who;
	this.extend({
		removing: who
	});
	this.emit("usermetrics:trigger:track", "open remove managed contact confirmation popup", {
		who,
	});
}

function handle_contact_trigger_remove_cancel() {
	this.extend({
		removing: false
	});
	this.emit("usermetrics:trigger:track", "close remove managed contact confirmation popup", {
		who: this.data.who,
	});
}
